import { FunnelOrder } from '../../../../data/models/funnelOrder'
import {
  DayOption,
  driveOptions,
  flyOptions,
} from '../../../../data/models/funnelOrder/days'
import { destinationEnum } from '../../../../data/models/funnelOrder/destination'
import { roomType } from '../../../../data/models/funnelOrder/roomType'
import { Theme } from '../../../../data/models/funnelOrder/theme'
import {
  IncomingTime,
  OutgoingTime,
} from '../../../../data/models/funnelOrder/times'
import { ParsedQueryString } from '../../../../utils/urls'
import { QueryKey } from '../wrapper'

export function getOptions(
  query: ParsedQueryString,
  funnelOrder: FunnelOrder,
  queryKeys: QueryKey[],
) {
  const order: Partial<FunnelOrder> = {}

  // Number of days
  if (queryKeys.includes(QueryKey.numberOfDays)) {
    if (funnelOrder.theme === Theme.fly || funnelOrder.theme === Theme.drive) {
      const numberOfDays = query[QueryKey.numberOfDays]
      switch (funnelOrder.theme) {
        case Theme.fly:
          const flyDays = getDayOptions(query, funnelOrder, flyOptions)
          if (flyDays !== null) {
            order.days = flyDays
          }
        case Theme.drive:
          const driveDays = getDayOptions(query, funnelOrder, driveOptions)
          if (driveDays !== null) {
            order.days = driveDays
          }
      }
    }
  }

  // DESTINATION
  if (queryKeys.includes(QueryKey.region)) {
    const region = query[QueryKey.region]
    if (
      region !== undefined &&
      Object.values(destinationEnum).includes(Number(region))
    ) {
      const destination: destinationEnum = Number(region)
      order.destination = destination
    }

    if (funnelOrder.theme === Theme.fly) {
      if (
        order.destination === destinationEnum.outsideEurope &&
        order.days !== 7
      ) {
        order.days = 7
      } else if (
        order.destination !== destinationEnum.outsideEurope &&
        order.days === 7
      ) {
        order.days = 3
      }
    }
  }

  // OUTGOING TIME RANGE
  if (queryKeys.includes(QueryKey.outboundDepartureTime)) {
    const outboundDepartureTime = query[QueryKey.outboundDepartureTime]
    if (
      outboundDepartureTime !== undefined &&
      Object.values(OutgoingTime).includes(Number(outboundDepartureTime))
    ) {
      order.outgoingTime = Number(outboundDepartureTime)
    }
  }

  // INCOMING TIME RANGE
  if (queryKeys.includes(QueryKey.inboundDepartureTime)) {
    const inboundDepartureTime = query[QueryKey.inboundDepartureTime]
    if (
      inboundDepartureTime !== undefined &&
      Object.values(IncomingTime).includes(Number(inboundDepartureTime))
    ) {
      order.incomingTime = Number(inboundDepartureTime)
    }
  }

  // ROOM TYPE
  if (queryKeys.includes(QueryKey.roomType)) {
    const seletedRoomType = query[QueryKey.roomType]
    if (
      seletedRoomType !== undefined &&
      Object.values(roomType).includes(Number(seletedRoomType))
    ) {
      order.roomType = Number(seletedRoomType)
    }
  }

  return order
}

function getDayOptions(
  query: ParsedQueryString,
  funnelOrder: FunnelOrder,
  options: DayOption[],
) {
  const numberOfDays = query[QueryKey.numberOfDays]
  if (
    numberOfDays !== undefined &&
    options.map(x => x.days).includes(Number(numberOfDays)) &&
    Number(numberOfDays) !== funnelOrder.days
  ) {
    return Number(numberOfDays)
  }
  return null
}
